import React from 'react'

import AboutCallout from '../components/AboutCallout/AboutCallout'

const About = () => (
  <div>
    <article>
      <h1 className="title__page">About</h1>
      <div className="section">
        <div className="section__row section__row__2_up">
          <div className="section__content section__content__narrow">
            <h3>The Commonwealth Fund’s <em>2020 Scorecard on State Health
              System Performance</em> assesses all 50 states and the District of
              Columbia on 49 measures of access to health care, quality
              of care, service use and costs of care, health outcomes, and
              income-based health care disparities.</h3>
          </div>
          <div className="section__content section__content__wide section__content__bulleted__regular">
            <h3>COVID-19</h3>
            <p>The 2020 Scorecard documents state-level variation in U.S. health care performance prior to COVID-19’s emergence. The report draws on the most currently available, comprehensive, state-level data, which unfortunately lags in this rapidly evolving environment. Still, the report provides important state-specific context for discussing the pandemic’s implications.</p>
            <h3>What's new?</h3>
            <p>The 2020 Scorecard introduces new
              performance measures:
            <ul>
              <li>State-based public health spending.</li>
              <li>Primary care spending among Medicare beneficiaries and those with
                  employer coverage.
              </li>
            </ul>
            </p>
            <p>
              Also included are data on racial and ethnic inequity,
              focusing on the disparity between white people and
              communities of color for a subset of indicators spanning
              health care access, quality, and health outcomes. (These
              data are referenced throughout the report but are not
              used to calculate state rankings.)</p>
            <p>For the first time, the 2020 Scorecard also reports price
              information for health services at a state level (not used in
              state rankings).</p>
          </div>
        </div>
      </div>
      <AboutCallout />
    </article>
  </div>
)

export default About

export const query = graphql`
    query AboutQuery {
        site {
            pathPrefix
            siteMetadata {
                title
                year
                subtitle
                siteUrl
                siteDescription
            }
        }
        allThemesJson {
            edges {
                node {
                    theme_id
                    title
                    path
                    stat {
                        suffix
                        number
                        text
                    }
                }
            }
        }
        allSocialJson {
            edges {
                node {
                    page_id
                    path
                    title
                    share_path
                    exhibit
                }
            }
        }
    }
`



// WEBPACK FOOTER //
// ./src/pages/about.js